import { FunctionComponent, useEffect, useState } from "react";
import styles from "./PublishPopup.module.css";
import { Autocomplete, Button, InputAdornment, TextField } from "@mui/material";
import images from "../../../assets/images";
import { CustomTextField, InputPropsForAddAffiliates } from "../../../helper";
import { useForm } from "react-hook-form";
import { useLazyQuery } from "@apollo/client";
import { GET_REFERRED_AFFILIATES } from "../../../features/Affiliate/api/AffiliateQuery";
import { getAutocompleteoutlinewidthStyles, getAutocompleteStyles } from "../../../style/getAutoCompleteStyles";

interface PopupProps {
  handleClose: () => void;
  title: string;
  subTitle: string;
  handleAllow : any
  affiliate ? : boolean
  delist ? : boolean
  returnTicket ? : boolean
  bulkTicketsPublish? : string[]
  voidPayout?: boolean
}

interface ReferAffiliateType {
  id: string;
  name: string;
  code: string;
}

interface RefAffType {
  user: { 
    u_id: string; 
    u_full_name: string; 
    u_referral_code: string 
  }
}

const InputField = CustomTextField();

const PublishPopup: FunctionComponent<PopupProps> = ({
  handleClose,
  title,
  subTitle,
  handleAllow,
  affiliate,
  bulkTicketsPublish,
  delist,
  returnTicket,
  voidPayout
}) => {
  const { publishpopup, Deletepopup, ReturnPopupIcon} = images;

  const [listprice, setListPrice] = useState<string>("");
  const [errorForZero, setErrorForZero] = useState<string>("")
  const [referredId, setReferredId] = useState<null | string | undefined>(null);
  const [referAffiliate, setReferAffiliate] = useState([]);
  const {
    register,
    handleSubmit,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {listPrice : ""},
    mode: "onTouched",
  });

  const [getReferredAffiliates] = useLazyQuery(GET_REFERRED_AFFILIATES,{
    fetchPolicy: "no-cache",
    onCompleted: (data)=>{
      const referredAff = data?.affiliates?.map((resp: RefAffType)=>({
        id: resp?.user?.u_id,
        name: resp?.user?.u_full_name, 
        code: resp?.user?.u_referral_code
      }))
      setReferAffiliate(referredAff);
    }
  })
  useEffect(() => {
    if(title === 'Select an Affiliate to Refer') {
      getReferredAffiliates();
    }
  },[])

  const handleSubmitListPrice = (formData: {listPrice: string}) => {
    if(title === 'Select an Affiliate to Refer') {
      if(referredId) {
        handleAllow(referredId);
      } else {
        setErrorForZero("Please select an affiliate");
      }
    } else {
      if(parseFloat(formData?.listPrice) <= 0 ){
        setErrorForZero("Price must be greater than zero");
      } else {
        handleAllow(listprice);
      }
    }
  }

  const handleChangeListPrice = (e : React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setErrorForZero("");
    const regexPattern = /^(0|[1-9]\d*)(\.\d{0,2})?$/;
    if (regexPattern.test(input)) {
      if (parseFloat(input) <= 100000 && parseFloat(input) >= 0) {
        setValue("listPrice", input);
        setListPrice(input);
        trigger("listPrice");
      }
    } else {
      setListPrice(listprice);
    }
  }

  const handleKeyDown = (e :any) =>{
    if(e.key === 'Backspace'){
      if(listprice.length === 1){
        setListPrice("")
      }
    }
  }
  const handleReferAffiliateInput = (value: any) => {
    setReferredId(value)
  }

  return (
    <div className={styles.topSection}>
     <form onSubmit={handleSubmit(handleSubmitListPrice)} className={styles.formStyle}>
      {/* { delist &&<ApprovalMessage title={title} subTitle={subTitle}/> } */}
      <div className={styles.topContent}>
        <div className={styles.utilitiesPopupStatus}>
          <img
            className={styles.roundedOutlineDone}
            alt="publishPopupIcon"
            src={affiliate || delist ? Deletepopup: returnTicket ? ReturnPopupIcon : publishpopup}
          />
        </div>
        <div className={styles.textContainer}>
          {bulkTicketsPublish?.length ? 
          <b className={styles.emailSentSuccessfully}>{title + " ("+ bulkTicketsPublish?.length + ")"}</b> :
          <b className={styles.emailSentSuccessfully}>{title}</b>
          }
          { (delist || returnTicket || voidPayout || title === 'Add Ticket?' || title === 'Copy and Proceed?' || title === 'Proceed with update?') && <b className={styles.weHaveSent}>{subTitle}</b>}
        </div>
      {
      title === "Delete Affiliate?" || title === 'Delist?' || title === 'Return?' || title === 'Voided Payout?' || title === 'Unvoided Payout?' || title == 'Move to List?' || title == 'Add Ticket?'
      || title === "Copy and Proceed?" || title === 'Proceed with update?' || title === 'Select an Affiliate to Refer' || title === 'Deactivate?'
      ? ""
      : <div className={styles.listTicketContainer} style={{margin: '10px 0px'}}>
            <div className={styles.listTicketText} style={{ padding: '10px 0px'}}>List Price for each ticket</div>
                <InputField 
                        variant="outlined"
                        {...register("listPrice",{
                          required: "List price is required!",
                        })}
                        data-testid='listPrice'
                        fullWidth
                        placeholder={'Enter your list price'}
                        value={listprice}
                        onChange={ (e: React.ChangeEvent<HTMLInputElement>) => handleChangeListPrice(e)}
                        style={{ width:'300px'}} 
                        error = {Boolean(errors?.listPrice?.message) || Boolean(errorForZero)}  
                        InputProps={{
                          style: InputPropsForAddAffiliates,
                          startAdornment: (
                            <InputAdornment position="start">
                              {`$`}
                            </InputAdornment>
                          ),
                        }}  
                        onKeyDown={handleKeyDown} 
                    />
                    <span className={styles.errorMsgStyle}>{errors?.listPrice?.message ? errors?.listPrice?.message : errorForZero ? errorForZero : ""}</span>
        </div>
      }
      {
        title === 'Select an Affiliate to Refer' &&
       <div style = {{marginTop: 20}}>
          <Autocomplete
          disablePortal
          id="combo-box-demo"
          sx={[getAutocompleteStyles(false),getAutocompleteoutlinewidthStyles]}
          fullWidth
          options={referAffiliate ?? []}
          onChange={(event, newValue) => {
            if(newValue?.id) {
              setReferredId(newValue.id);
              setErrorForZero("");
            } else {
              setReferredId(null);
            }
          }}
          onInputChange={handleReferAffiliateInput}
          autoHighlight
          getOptionLabel={(option: ReferAffiliateType) => `${option?.name} - ${option.code}` || "-"}
          isOptionEqualToValue={(option: ReferAffiliateType, value: ReferAffiliateType) => option?.id === value?.id}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Select Affiliate"
              InputLabelProps={{ shrink: true }}
              error = {Boolean(errors?.listPrice?.message) || Boolean(errorForZero)}  
              onClick={async () => {
                await getReferredAffiliates();
              }}
            />
          )}
        />
        <span className={styles.errorMsgStyle}>{errors?.listPrice?.message ? errors?.listPrice?.message : errorForZero ? errorForZero : ""}</span>
        </div>

      }
      </div>
      <div className={styles.cta}>
        <div className={styles.button} onClick={handleClose}>
          <Button
            sx={{
              height: "44px",
              width: "138px",
              borderRadius: 0,
              "&.MuiButton-root": {
                textTransform: "capitalize",
                fontWeight: "bold",
                fontSize: "var(--sub-s-h2-16-semibold-center-size)",
                fontFamily: "var(--body-b3-12-semibold-left)",
                color: "#151A34",
                backgroundColor: "#F3F4F6",
                border: "1px solid #E3E5E8",
              },
            }}
          >
            Cancel
          </Button>
        </div>
        <div className={styles.button}>
          <Button
            sx={{
              height: "44px",
              width: "138px",
              borderRadius: 0,
              "&.MuiButton-root": {
                textTransform: "capitalize",
                fontWeight: "bold",
                fontSize: "var(--sub-s-h2-16-semibold-center-size)",
                fontFamily: "var(--body-b3-12-semibold-left)",
                color: "var(--neutral-white)",
                backgroundColor: "var(--branding-secondary)",
              },
            }}
            type="submit"
            onClick={(e) => {
              if(title === 'Delete Affiliate?' || title === 'Delist?' || title === 'Return?' ||  title === 'Voided Payout?' || title === 'Unvoided Payout?' || title == 'Move to List?' || title === 'Deactivate?'){
                handleAllow(e);
              }else {}
            }}
          >
            {(delist || returnTicket ) ? `Confirm`: 'Submit'}
          </Button>
        </div>
      </div>
      </form>
    </div>
  );
};

export default PublishPopup;
